// // import apiClient from "./apiClient"; // Import our new centralized client

// // // --- LOGIN ---
// // export const login = async (username_or_email, password) => {
// //   const payload = { username_or_email, password };
// //   // Use apiClient, no need for the full URL or manual headers.
// //   const response = await apiClient.post("/login/", payload);
// //   const data = response.data;

// //   // This service is responsible for the side-effect of storing tokens.
// //   if (response.status === 200 && data.access) {
// //     const userData = {
// //       username: data.username,
// //       email: data.email,
// //       phone_number: data.phone_number,
// //       role: data.user_role.toLowerCase(),
// //     };
// //     localStorage.setItem("gatep_user", JSON.stringify(userData));
// //     localStorage.setItem("access_token", data.access);
// //     localStorage.setItem("refresh_token", data.refresh);
// //     return userData; // Return the user data to the caller (our context).
// //   }
// //   // If login fails, throw an error to be caught by the caller.
// //   throw new Error(data.message || "Login failed.");
// // };

// // // --- REGISTER ---
// // export const register = (apiPayload) => {
// //   return apiClient.post("/register/", apiPayload);
// // };

// // // --- VERIFY OTP ---
// // export const verifyOtp = (otpPayload) => {
// //   return apiClient.post("/verify-otp/", otpPayload);
// // };

// // // --- RESEND OTP ---
// // export const resendOtp = (resendPayload) => {
// //   return apiClient.post("/resend-otp/", resendPayload);
// // };

// // // --- FORGOT PASSWORD ---
// // export const forgotPassword = (email) => {
// //   return apiClient.post("/forgot-password/", { email });
// // };

// // // --- LOGOUT ---
// // export const logout = () => {
// //   // Centralize the logic for clearing the user's session data.
// //   localStorage.removeItem("gatep_user");
// //   localStorage.removeItem("access_token");
// //   localStorage.removeItem("refresh_token");
// //   // If you have a backend logout endpoint, you could call it here.
// //   // apiClient.post('/logout/');
// // };

// import apiClient from "./apiClient"; // Import our new centralized client

// // --- LOGIN ---
// export const login = async (username_or_email, password) => {
//   const payload = { username_or_email, password };
//   // Use apiClient, no need for the full URL or manual headers.
//   const response = await apiClient.post("/login/", payload);
//   const data = response.data;

//   // This service is responsible for the side-effect of storing tokens.
//   if (response.status === 200 && data.access) {
//     const userData = {
//       username: data.username,
//       email: data.email,
//       phone_number: data.phone_number,
//       role: data.user_role.toLowerCase(),
//     };
//     localStorage.setItem("gatep_user", JSON.stringify(userData));
//     localStorage.setItem("access_token", data.access);
//     localStorage.setItem("refresh_token", data.refresh);
//     return userData; // Return the user data to the caller (our context).
//   }
//   // If login fails, throw an error to be caught by the caller.
//   throw new Error(data.message || "Login failed.");
// };

// // --- REGISTER ---
// export const register = (apiPayload) => {
//   return apiClient.post("/register/", apiPayload);
// };

// // --- VERIFY OTP ---
// export const verifyOtp = (otpPayload) => {
//   return apiClient.post("/verify-otp/", otpPayload);
// };

// // --- RESEND OTP ---
// export const resendOtp = (resendPayload) => {
//   return apiClient.post("/resend-otp/", resendPayload);
// };

// // --- FORGOT PASSWORD ---
// export const forgotPassword = (email) => {
//   return apiClient.post("/forgot-password/", { email });
// };

// // --- LOGOUT ---
// export const logout = () => {
//   // Centralize the logic for clearing the user's session data.
//   localStorage.removeItem("gatep_user");
//   localStorage.removeItem("access_token");
//   localStorage.removeItem("refresh_token");
//   // If you have a backend logout endpoint, you could call it here.
//   // apiClient.post('/logout/');
// };

// // --- GET NOTIFICATIONS ---
// export const getNotifications = async () => {
//   try {
//     const response = await apiClient.get("/notifications/");
//     // The service ensures we always return an array
//     if (response.data && Array.isArray(response.data)) {
//       return response.data;
//     }
//     return []; // Return an empty array if the response is not as expected
//   } catch (error) {
//     console.error("Failed to fetch notifications in service", error);
//     // Throw the error so the context can handle it, or return empty array
//     return [];
//   }
// };
import apiClient from "./apiClient"; // Import our new centralized client

// --- LOGIN ---
export const login = async (username_or_email, password) => {
  const payload = { username_or_email, password };
  // Use apiClient, no need for the full URL or manual headers.
  const response = await apiClient.post("/login/", payload);
  const data = response.data;

  // This service is responsible for the side-effect of storing tokens.
  if (response.status === 200 && data.access) {
    const userData = {
      username: data.username,
      email: data.email,
      phone_number: data.phone_number,
      role: data.user_role.toLowerCase(),
    };
    localStorage.setItem("gatep_user", JSON.stringify(userData));
    localStorage.setItem("access_token", data.access);
    localStorage.setItem("refresh_token", data.refresh);
    return userData; // Return the user data to the caller (our context).
  }
  // If login fails, throw an error to be caught by the caller.
  throw new Error(data.message || "Login failed.");
};

// --- REGISTER ---
export const register = (apiPayload) => {
  return apiClient.post("/register/", apiPayload);
};

// --- VERIFY OTP ---
export const verifyOtp = (otpPayload) => {
  return apiClient.post("/verify-otp/", otpPayload);
};

// --- RESEND OTP ---
export const resendOtp = (resendPayload) => {
  return apiClient.post("/resend-otp/", resendPayload);
};

// --- FORGOT PASSWORD ---
export const forgotPassword = (email) => {
  return apiClient.post("/forgot-password/", { email });
};

// --- LOGOUT ---
export const logout = () => {
  // Centralize the logic for clearing the user's session data.
  localStorage.removeItem("gatep_user");
  localStorage.removeItem("access_token");
  localStorage.removeItem("refresh_token");
  // If you have a backend logout endpoint, you could call it here.
  // apiClient.post('/logout/');
};

// --- GET NOTIFICATIONS ---
export const getNotifications = async () => {
  try {
    const response = await apiClient.get("/notifications/");
    // The service ensures we always return an array
    if (response.data && Array.isArray(response.data)) {
      return response.data;
    }
    return []; // Return an empty array if the response is not as expected
  } catch (error) {
    console.error("Failed to fetch notifications in service", error);
    // Throw the error so the context can handle it, or return empty array
    return [];
  }
};

// +++ ADDED FUNCTION TO UPDATE NOTIFICATION STATUS +++
export const updateNotificationStatus = async (id, newStatus, isRead) => {
  try {
    const payload = {
      new_status: newStatus,
      is_read: isRead,
    };
    const response = await apiClient.patch(
      `/notifications/${id}/status/`,
      payload
    );
    return response.data; // Return the success message
  } catch (error) {
    console.error("Failed to update notification status in service", error);
    // Re-throw the error to be handled by the caller (the context)
    throw error;
  }
};
